import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Autocomplete, Box, Slide, TextField, Typography } from "@mui/material";
import { marked } from "marked";
import React, { Fragment } from "react";
import BooleanStringIco from "../../../../assets/icons/BooleanStringIco";
import ButtonSearchIco from "../../../../assets/icons/ButtonSearchIco";
import ChatBotInputIco from "../../../../assets/icons/ChatBotInputIco";
import SearchStrategyIco from "../../../../assets/icons/SearchStrategyIco";
import CommonButton from "../../../../component/Button";
import CommonTextField from "../../../../component/Input";
import DropDownSelect from "../../../../component/Select";
import { HandleSkeletion, highlightBoolean } from "../../../../utils/constants";
import { CustomDiv } from "../../../chat-bot/style";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import CandidateProgress from "../../../jobs/candidate-scoring/components/CandidateProgress";
import {
  CustomIconButton,
  CustomizeSpan,
  CustomUnOrderList,
} from "../../../jobs/style";
import CommonTable from "../../Table";
import MonsterLogo from "../../../../assets/images/MonsterLogo.png";

export default function Search({
  headerData,
  data,
  handleSearch,
  handleEditSearch,
  handleSearchExternalDatabase,
  handleSearchTableBodyData,
  handleAddCandidate,
  checkSelected,
  candidateSourcing,
  processConditionCheck,
  jobTitles,
  handleJobSelect,
  bounds,
  handleNext,
  handlePrev,
  activeIndex,
  handleBooleanStringEdit,
  handleSelectType,
  handleHubTableBodyData,
  handleDetails,
  handleAddToJob,
    externalValidating,
}) {
  return (
    <Fragment>
      <CommonGrid2
        display={"flex"}
        flexWrap={"wrap"}
        gap={"5px"}
        marginBottom={"0rem"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <CommonGrid2 display={"flex"} flexWrap={"wrap"} gap={"5px"}>
          {/*  <Typography
            variant="h3"
            color="#8396A8"
            fontWeight={700}
            sx={{
              background: "linear-gradient(149deg, #5A35B2 3.87%, #FA4F96 80%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Hi, <CustomizeSpan color="#6941C6">I am Hailey!</CustomizeSpan>
          </Typography>
          <Typography variant="h3" color="#8396A8" fontWeight={700}>
            I am your Headhunting Assistant
          </Typography>*/}
        </CommonGrid2>
        {!data.search_enable ? (
          ""
        ) : (
          <Fragment>
            {!data.edit_enable ? (
              <CustomDiv textAlign="end">
                <CommonButton
                  value={"Edit"}
                  variant="outlined"
                  width={"max-content"}
                  padding={"5px 12px"}
                  // marginTop={"-1rem"}
                  fontWeight={"700"}
                  fontSize={"15px"}
                  color="#344054"
                  disabled={
                    data.loading ||
                    data.search_external_loading ||
                    (candidateSourcing &&
                      candidateSourcing.data.length !== 0 &&
                      candidateSourcing.status === "Inprogress")
                  }
                  border="#D0D5DD"
                  onClick={handleEditSearch}
                />
              </CustomDiv>
            ) : (
              <CommonGrid2 display="flex" gap="10px" alignItems="center">
                <CustomIconButton
                  onClick={handlePrev}
                  disabled={activeIndex.index === 0}
                >
                  <KeyboardArrowLeftIcon
                    sx={{
                      color: activeIndex.index === 0 ? "#BEBEC7" : "#7F56D9",
                    }}
                  />
                </CustomIconButton>

                <CustomIconButton
                  onClick={handleNext}
                  disabled={
                    activeIndex.index === data.full_message_data.length - 1
                  }
                >
                  <KeyboardArrowRightIcon
                    sx={{
                      color:
                        activeIndex.index === data.full_message_data.length - 1
                          ? "#BEBEC7"
                          : "#7F56D9",
                    }}
                  />
                </CustomIconButton>
              </CommonGrid2>
            )}
          </Fragment>
        )}
      </CommonGrid2>
      {processConditionCheck ? (
        <CandidateProgress checkSelected={candidateSourcing.data} />
      ) : (
        <Fragment>
          {!data.search_enable ? (
            <CommonGrid2
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"space-between"}
            >
              <CommonGrid2 container spacing={2}>
                {data.data.map((item) => (
                  <CommonGrid2
                    background="#FFFFFF"
                    padding={"12px"}
                    borderRadius={"10px"}
                    border={"1px solid #EAECF0"}
                    item
                    size={{
                      xs: 12,
                      md: bounds.width < 850 ? 4 : 3,
                      sm: 4,
                    }}
                  >
                    <CommonGrid2 display={"flex"} gap={"12px"}>
                      <>{item.icon}</>
                      <CommonGrid2
                        display={"flex"}
                        flexDirection={"column"}
                        gap={"5px"}
                      >
                        <Typography variant="body4" fontWeight={600}>
                          {item.name}
                        </Typography>
                        <Typography variant="subtitle2" fontWeight={500}>
                          {item.desctiption}
                        </Typography>
                      </CommonGrid2>
                    </CommonGrid2>
                  </CommonGrid2>
                ))}
              </CommonGrid2>
            </CommonGrid2>
          ) : (
            <Fragment>
              <CommonGrid2 container spacing={2} size={12}>
                <CommonGrid2
                  item
                  size={{ xs: 12, md: bounds?.width < 750 ? 12 : 6 }}
                >
                  <CommonGrid2
                    display={"flex"}
                    gap={"5px"}
                    marginBottom={"5px"}
                    alignItems={"center"}
                  >
                    <SearchStrategyIco />
                    <Typography variant="h6">Search Strategy</Typography>
                  </CommonGrid2>
                  {data.loading ? (
                    <HandleSkeletion height={200} transform={"scale(1)"} />
                  ) : (
                    <CommonGrid2
                      padding={"10px"}
                      border={"1px solid #ddd"}
                      borderRadius={"8px"}
                      backgroundColor={"#EBF8FF"}
                      overflowY={"auto"}
                      scrollBar="5px"
                      height={"465px"}
                      scrollStyle={true}
                      position={"relative"}
                      display={"flex"}
                      flexDirection={"column"}
                      justifyContent={"space-between"}
                    >
                      <CommonGrid2 flexDirection={"column"}>
                        <Slide
                          in={true}
                          key={activeIndex.index}
                          direction={"up"}
                          timeout={500}
                          mountOnEnter
                          unmountOnExit
                        >
                          <CustomDiv>
                            <Typography fontSize={"14px"} color="#00144A">
                              <CustomizeSpan fontWeight={700} color="#00144A">
                                {" "}
                                Search Strategy:
                              </CustomizeSpan>{" "}
                              I have analyzed your request and here is what you
                              need to know,
                            </Typography>
                            <CustomUnOrderList padding="0px 0px 0px 30px">
                              {data?.full_message_data?.[
                                activeIndex.index
                              ]?.cheat_sheet.map((listItem) => (
                                <li
                                  style={{
                                    fontSize: "14px",
                                    color: "#00144A",
                                    fontFamily: "Inter",
                                  }}
                                >
                                  <div
                                    className="markdown-content"
                                    dangerouslySetInnerHTML={{
                                      __html: marked(listItem),
                                    }}
                                  />
                                </li>
                              ))}
                            </CustomUnOrderList>
                          </CustomDiv>
                        </Slide>
                      </CommonGrid2>
                    </CommonGrid2>
                  )}
                </CommonGrid2>
                <CommonGrid2
                  item
                  size={{ xs: 12, md: bounds?.width < 750 ? 12 : 6 }}
                >
                  <CommonGrid2
                    display={"flex"}
                    gap={"5px"}
                    alignItems={"center"}
                    marginBottom={"5px"}
                  >
                    <BooleanStringIco />
                    <Typography variant="h6">Boolean String</Typography>
                  </CommonGrid2>
                  {data.loading ? (
                    <HandleSkeletion height={200} transform={"scale(1)"} />
                  ) : (
                    <CommonGrid2
                      border="1px solid #ddd"
                      borderRadius="8px"
                      padding="10px"
                      background="#fafafa"
                      justifyContent={"space-between"}
                      display={"flex"}
                      overflow={"hidden"}
                      flexDirection={"column"}
                    >
                      <Slide
                        in={true}
                        key={activeIndex.index}
                        direction={activeIndex.direction}
                        timeout={500}
                        mountOnEnter
                        unmountOnExit
                      >
                        <CustomDiv>
                          <CommonGrid2
                            display={"flex"}
                            flexDirection={"column"}
                            gap={"5px"}
                          >
                            <Typography variant="body4" fontWeight={600}>
                              Generic Search String
                            </Typography>
                            {data.edit_enable ? (
                              <CommonTextField
                                rows={3}
                                multiline
                                disabled={!data.edit_enable}
                                padding={"0px"}
                                value={
                                  data?.full_message_data?.[activeIndex.index]
                                    ?.search_strategy?.general_search_string
                                }
                                fontSize={"13px"}
                                onChange={(e) =>
                                  handleBooleanStringEdit(
                                    e,
                                    "general_search_string"
                                  )
                                }
                                customStyle={{
                                  "& .MuiInputBase-root": {
                                    padding: "0px",
                                  },
                                  "& textarea": {
                                    padding: "12px !important",
                                  },
                                }}
                              />
                            ) : (
                              <Box
                                border="1px solid #D0D5DD"
                                borderRadius="8px"
                                padding="10px"
                                height="155px"
                                backgroundColor="#F9FAFB"
                                fontSize="14px"
                                sx={{
                                  overflowY: "auto",
                                }}
                              >
                                <Typography
                                  component="div"
                                  color="green"
                                  dangerouslySetInnerHTML={{
                                    __html: highlightBoolean(
                                      data?.full_message_data?.[
                                        activeIndex.index
                                      ]?.search_strategy?.general_search_string
                                    ),
                                  }}
                                />
                              </Box>
                            )}
                          </CommonGrid2>
                          <CommonGrid2
                            display={"flex"}
                            flexDirection={"column"}
                            gap={"5px"}
                            marginTop={"1rem"}
                          >
                            <CommonGrid2
                              display={"flex"}
                              alignItems={"center"}
                              gap={"5px"}
                            >
                              {<img src={MonsterLogo} width={"20px"} />}
                              <Typography variant="body4" fontWeight={600}>
                                Monster Search String
                              </Typography>
                            </CommonGrid2>
                            {data.edit_enable ? (
                              <CommonTextField
                                rows={3}
                                multiline
                                disabled={!data.edit_enable}
                                padding={"0px"}
                                value={
                                  data?.full_message_data?.[activeIndex.index]
                                    ?.search_strategy
                                    ?.monster_specific_search_string
                                }
                                fontSize={"13px"}
                                onChange={(e) =>
                                  handleBooleanStringEdit(
                                    e,
                                    "monster_specific_search_string"
                                  )
                                }
                                customStyle={{
                                  "& .MuiInputBase-root": {
                                    padding: "0px",
                                  },
                                  "& textarea": {
                                    padding: "12px !important",
                                  },
                                }}
                              />
                            ) : (
                              <Box
                                border="1px solid #D0D5DD"
                                borderRadius="8px"
                                padding="10px"
                                height="155px"
                                backgroundColor="#F9FAFB"
                                fontSize="14px"
                                sx={{
                                  overflowY: "auto",
                                }}
                              >
                                <Typography
                                  component="div"
                                  color="green"
                                  dangerouslySetInnerHTML={{
                                    __html: highlightBoolean(
                                      data?.full_message_data?.[
                                        activeIndex.index
                                      ]?.search_strategy
                                        ?.monster_specific_search_string
                                    ),
                                  }}
                                />
                              </Box>
                            )}
                          </CommonGrid2>
                        </CustomDiv>
                      </Slide>

                      {/* {!data.table_data && ( */}
                      <CommonGrid2
                        size={12}
                        textAlign={"end"}
                        marginTop={"1rem"}
                      >
                        <CommonButton
                          startIcon={
                            !data.search_external_loading && <ButtonSearchIco />
                          }
                          gap={data.search_external_loading ? "10px" : "0px"}
                          fontWeight={600}
                          onClick={handleSearchExternalDatabase}
                          disabled={
                            data.loading ||
                            !data.edit_enable ||
                            data.search_external_loading
                          }
                          loading={data.search_external_loading}
                          padding={"10px 1.5rem"}
                          value={"Search your Database"}
                        />
                      </CommonGrid2>
                      {/* )} */}
                    </CommonGrid2>
                  )}
                </CommonGrid2>
              </CommonGrid2>
              {data.loading ? (
                <HandleSkeletion height={200} />
              ) : (
                data.edit_enable && (
                  <CommonGrid2
                    marginTop={"1.2rem"}
                    display={"flex"}
                    flexDirection={"column"}
                    padding={"1rem"}
                    borderRadius={"10px"}
                    boxShadow="0px 0px 20.5px 0px #7F56D933"
                    background="#fff"
                  >
                    <Typography
                      variant="h3"
                      color="#8396A8"
                      fontWeight={700}
                      sx={{
                        background:
                          "linear-gradient(149deg, #5A35B2 3.87%, #FA4F96 30%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                      }}
                    >
                      Who are you looking for ?
                    </Typography>

                    <CommonGrid2
                      overflowY={"auto"}
                      height={"150px"}
                      position={"relative"}
                      display={"flex"}
                      flexDirection={"column"}
                      justifyContent={"space-between"}
                      margin={data.message.length === 0 ? "0" : "0px 0px 12px"}
                      scrollStyle={true}
                      padding={"0px 10px"}
                      width={"100%"}
                      scrollBar="5px"
                    >
                      <CustomDiv>
                        {data.message &&
                          data.message.map((msg, index) => {
                            if (msg.sender === "user") {
                              return (
                                <CustomDiv
                                  key={index}
                                  textAlign={
                                    msg.sender === "user" ? "right" : "left"
                                  }
                                  margin={"12px 0"}
                                >
                                  {msg.text && (
                                    <Typography
                                      fontSize={"13px"}
                                      textAlign={"left"}
                                      style={{
                                        display: "inline-block",
                                        padding: "5px 10px",
                                        backgroundColor:
                                          msg.text !==
                                          data?.full_message_data?.[
                                            activeIndex.index
                                          ]?.text
                                            ? "#F1ECFF"
                                            : msg.sender === "user"
                                            ? "#7F56D9"
                                            : msg.sender === "error"
                                            ? "red"
                                            : "#fff",
                                        color:
                                          msg.text !==
                                          data?.full_message_data?.[
                                            activeIndex.index
                                          ]?.text
                                            ? "#6941C6"
                                            : msg.sender === "user" ||
                                              msg.sender === "error"
                                            ? "#fff"
                                            : "#000",
                                        borderRadius:
                                          msg.sender === "user"
                                            ? "8px 8px 1px 8px"
                                            : "8px 8px 8px 1px",
                                        maxWidth:
                                          msg.sender === "user"
                                            ? "90%"
                                            : "100%",
                                        wordBreak: "break-word",
                                        boxShadow:
                                          "1px 1px 5px 1px rgb(16 24 40 / 11%)",
                                      }}
                                    >
                                      {msg.text}
                                    </Typography>
                                  )}
                                </CustomDiv>
                              );
                            }
                          })}
                      </CustomDiv>
                    </CommonGrid2>

                    <CommonTextField
                      datePickerCalender
                      border={"2px solid #7F56D9"}
                      padding={"15px 15px 15px 10px"}
                      backgroundColor={"#F7F8F9"}
                      placeholder={"Refine your search"}
                      bgColor={"#F7F8F9"}
                      fontSize={"14px"}
                      value={data.search}
                      onChange={(e) => {
                        handleSearch(e, "inside_search");
                      }}
                      handleIconClick={() => handleSearch("", "inside_click")}
                      // disabled={chatBotData.loader || disabled}
                      calenderIcon={<ChatBotInputIco color="#7F56D9" />}
                      customStyle={{
                        position: "sticky",
                        bottom: "0px",
                        right: "0px",
                      }}
                    />
                  </CommonGrid2>
                )
              )}
            </Fragment>
          )}
          {data.table_data &&
            data.sourcing_data.map((item, index) => {
              console.log(item, data.sourcing_data, "sflksmflsmflsfml");
              return (
                <CommonGrid2>
                  <CommonGrid2
                    display={"flex"}
                    flexWrap={"wrap"}
                    justifyContent={"space-between"}
                    marginTop={"2rem"}
                    gap={"1rem"}
                    alignItems={"center"}
                  >
                    <Typography variant="h6">{item.title}</Typography>
                    <CommonGrid2
                      container
                      alignItems="flex-start"
                      spacing={2}
                      flexWrap={"wrap"}
                    >
                      {index === 1 ? (
                        <Fragment>
                          <DropDownSelect
                            marginTop="0px"
                            fullWidth={false}
                            title={"Select the type"}
                            sizeMedium="-4px"
                            removeAnimation={true}
                            padding={"13px 32px 13px 12px"}
                            data={jobTitles.droppDown_data}
                            error={jobTitles.droppDown_value === ""}
                            helperText={
                              jobTitles.droppDown_value === "" &&
                              "Select the type"
                            }
                            value={jobTitles.droppDown_value || ""}
                            handleChange={handleSelectType}
                            customStyle={{ width: "200px" }}
                          />
                          {jobTitles.droppDown_value === "Add to Job" && (
                            <Autocomplete
                              options={jobTitles.data || []}
                              getOptionLabel={(opt) => opt.label || opt}
                              onChange={(event, value) =>
                                handleJobSelect(value, index)
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder={"Search for Job or Company"}
                                  error={jobTitles.value === ""}
                                  helperText={
                                    jobTitles.value === "" && "Select a job"
                                  }
                                />
                              )}
                              sx={{
                                "& .MuiAutocomplete-inputRoot": {
                                  width: "300px",
                                  padding: "5px",
                                  border: "1px solid #D0D5DD",
                                  alignItems: "center",
                                  borderRadius: "8px",
                                  backgroundColor: "#FFFFFF",
                                },
                                "& .MuiInputBase-input::placeholder": {
                                  color: "#667085",
                                  opacity: 1,
                                  fontSize: "16px",
                                  fontWeight: 400,
                                },
                                "& .Mui-error .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderWidth: "1.5px",
                                  },
                                "& .Mui-error": {
                                  fontWeight: 600,
                                  margin: "1px 0px",
                                },
                              }}
                            />
                          )}
                        </Fragment>
                      ) : (
                        <Autocomplete
                          options={jobTitles.data || []}
                          getOptionLabel={(opt) => opt.label || opt}
                          onChange={(event, value) =>
                            handleJobSelect(value, index)
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder={"Search for Job or Company"}
                              error={jobTitles.job_value === ""}
                              helperText={
                                jobTitles.job_value === "" && "Select a job"
                              }
                            />
                          )}
                          sx={{
                            "& .MuiAutocomplete-inputRoot": {
                              width: "300px",
                              padding: "5px",
                              border: "1px solid #D0D5DD",
                              alignItems: "center",
                              borderRadius: "8px",
                              backgroundColor: "#FFFFFF",
                            },
                            "& .MuiInputBase-input::placeholder": {
                              color: "#667085",
                              opacity: 1,
                              fontSize: "16px",
                              fontWeight: 400,
                            },
                            "& .Mui-error .MuiOutlinedInput-notchedOutline": {
                              borderWidth: "1.5px",
                            },
                            "& .Mui-error": {
                              fontWeight: 600,
                              margin: "1px 0px",
                            },
                          }}
                        />
                      )}
                      <CommonButton
                        value={item.button}
                        gap={!externalValidating ? "0px" : "8px"}
                        padding={"10px 1rem"}
                        startIcon={!externalValidating && <AddIcon />}
                        disabled={
                          externalValidating ||
                          index === 0
                            ? checkSelected.candidateSelect.length === 0 &&
                              jobTitles.job_value !== ""
                            : checkSelected.externalSelect.length === 0
                        }
                        loading={externalValidating}
                        onClick={
                          index == 0 ? handleAddToJob : handleAddCandidate
                        }
                      />
                    </CommonGrid2>
                  </CommonGrid2>
                  {index === 1 && (
                    <CommonGrid2
                      display={"flex"}
                      flexWrap={"wrap"}
                      gap={"10px"}
                      alignItems={"center"}
                      marginTop={"1rem"}
                    >
                      <Typography variant="h5">Monster Filter:</Typography>
                      {item.filter.sort && (
                        <Typography
                          variant="body8"
                          width={"max-content"}
                          border={"1px solid #7F56D9"}
                          color="#7F56D9"
                          borderRadius={"5px"}
                          padding={"4px 6px"}
                          backgroundColor="rgb(105 65 198 / 13%)"
                        >
                          Sorted By - {item.filter.sort}
                        </Typography>
                      )}
                      {item.filter.date_range && (
                        <Typography
                          variant="body8"
                          width={"max-content"}
                          border={"1px solid #7F56D9"}
                          color="#7F56D9"
                          borderRadius={"5px"}
                          padding={"4px 6px"}
                          backgroundColor="rgb(105 65 198 / 13%)"
                        >
                          Date Range - Last {item.filter.date_range?.value}{" "}
                          Months
                        </Typography>
                      )}
                      {item.filter.education && (
                        <Typography
                          variant="body8"
                          width={"max-content"}
                          border={"1px solid #7F56D9"}
                          color="#7F56D9"
                          borderRadius={"5px"}
                          padding={"4px 6px"}
                          backgroundColor="rgb(105 65 198 / 13%)"
                        >
                          Education - {item.filter.education}
                        </Typography>
                      )}
                    </CommonGrid2>
                  )}
                  <CommonTable
                    marginTop="1rem"
                    data={
                      item.details === "See More"
                        ? (item.data && item.data.slice(0, 3)) || []
                        : item.data || []
                    }
                    columns={item.header}
                    loadingRowLength={3}
                    // handleTableBodyData={
                    //   index === 0
                    //     ? handleSearchTableBodyData
                    //     : handleSearchTableBodyData
                    // }
                    handleTableBodyData={
                      index === 0
                        ? handleHubTableBodyData
                        : handleSearchTableBodyData
                    }
                    withPagination={false}
                    loading={data.loading}
                  />

                  {item.data &&
                    item.data.length !== 0 &&
                    item.data.length > 3 && (
                      <CommonGrid2 margin={"0.5rem"} textAlign={"end"}>
                        <CommonButton
                          value={item.details}
                          variant="outlined"
                          color="#6941C6"
                          border="transparent"
                          fontWeight="700"
                          padding={"6px 20px"}
                          onClick={() => handleDetails(index, item)}
                        />
                      </CommonGrid2>
                    )}
                </CommonGrid2>
              );
            })}

          {!data.search_enable && (
            <CommonGrid2
              display={"flex"}
              flexDirection={"column"}
              gap={"1rem"}
              padding={"1rem"}
              borderRadius={"10px"}
              boxShadow="0px 0px 20.5px 0px #7F56D933"
              width={bounds.width - 8}
              position={"fixed"}
              bottom={"1.5rem"}
              background="#fff"
              margin={"0px 0px 0px -1rem"}
            >
              <Typography
                variant="h3"
                color="#8396A8"
                fontWeight={700}
                sx={{
                  background:
                    "linear-gradient(149deg, #5A35B2 3.87%, #FA4F96 30%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Who are you looking for ?
              </Typography>

              <CommonTextField
                datePickerCalender
                border={"1px solid #EAECF0"}
                padding={"15px 15px 15px 10px"}
                backgroundColor={"#F7F8F9"}
                placeholder={
                  "Just type the designation and some keywords of your ideal candidate.."
                }
                bgColor={"#F7F8F9"}
                value={data.search}
                onChange={(e) => {
                  handleSearch(e, "search");
                }}
                handleIconClick={() => handleSearch("", "click")}
                customStyle={{
                  borderRadius: "8px",
                  // width: bounds.width,
                  // position: "fixed",
                  // bottom: "1.5rem",
                  // boxShadow: "0px 0px 34.8px 0px #7F56D966",
                }}
                calenderIcon={
                  <CommonButton
                    value={"Search"}
                    startIcon={<ChatBotInputIco color="#fff" />}
                    gap="0px"
                    padding={"5px 1.2rem"}
                  />
                }
              />
            </CommonGrid2>
          )}
        </Fragment>
      )}
    </Fragment>
  );
}
